function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M1008.8,510.6c13.5,18.3,23.1,38.6,28.8,60.8c10.2-0.7,20.1-2.3,29.7-4.5 c0.9-5.3,1.3-10.6,1.3-16.1c0-28.3-12-53.7-31.1-71.6c-16.3,2.4-31.4,6.4-45.4,12.1C998,497.3,1003.6,503.7,1008.8,510.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E50069"
    },
    d: "M927.8,539.3c18.2,13.7,38.2,23.3,59.9,28.4c10.8,2.5,21.6,3.8,32.4,4.1 c-5.3-18.6-13.5-35.7-24.9-51.2c-5.8-7.9-12.3-15-19.3-21.6c-13.4,7.3-25.6,16.3-36.5,27.2C935.2,530.4,931.4,534.8,927.8,539.3z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M879.3,515.1c-4.3,11.1-6.8,23.2-6.8,35.8c0,14.4,3.1,28,8.7,40.3c5.5-16.7,13.2-33.3,23.5-48.9 C895.8,534.2,887.3,525.2,879.3,515.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E50069"
    },
    d: "M914.8,528.6c3.9-4.9,8.1-9.7,12.6-14.2c10.5-10.5,22-19.5,34.6-26.9 c-12.2-9.3-25.2-16.9-38.3-22.7c-14.7,8-27,19.6-36,33.7C896.2,509.7,905.2,519.8,914.8,528.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M1041.1,588.7c1.4,8.9,2.3,18,2.6,27.4c7.7-8.7,13.9-18.7,18.2-29.8 C1054.8,586.7,1047.9,587.5,1041.1,588.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M1024.6,592.4c-19,5.2-36.5,13.6-52.2,25.2c-10.9,8-20.5,17.4-28.8,27.5c8.6,2.5,17.7,3.8,27,3.8 c20.9,0,40.3-6.6,56.2-17.8C1027.3,617.6,1026.5,604.7,1024.6,592.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M962.3,604c9.7-7.1,19.9-13.1,30.6-18.1c-3-0.5-6.1-1.1-9.2-1.9c-24-5.7-46-16.1-65.9-31 c-11.8,18.4-19.9,38.6-24.7,58.1c9,11.5,20.5,21,33.7,27.5C937,625.9,948.7,614.1,962.3,604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009DD8"
    },
    d: "M978.5,478.8c12.5-5.8,25.9-10.2,40.2-13.4c-14.2-8-30.6-12.6-48.1-12.6c-8.9,0-17.5,1.2-25.6,3.4 C956.6,462.5,967.9,470,978.5,478.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 27,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 971,
    cy: 539.9,
    r: 213.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#009DD8",
      strokeWidth: 27,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M1128.8,396.8 c34.4,37.8,55.3,88.1,55.3,143.2c0,117.7-95.4,213.1-213.1,213.1S757.8,657.7,757.8,540c0-43.8,13.2-84.4,35.8-118.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#009DD8",
      strokeWidth: 34,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M1131.8,396.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b2c6666a.svg";
export { ForwardRef as ReactComponent };